import { addMonths, subDays } from 'date-fns';

type Props = {
  acceptedAt: string | null | undefined;
  maxUses: number | undefined;
};

export const getOfferEndDate = ({ maxUses, acceptedAt }: Props) => {
  if (!maxUses) {
    return undefined;
  }

  const startDate = new Date(acceptedAt ?? Date.now());
  let endDate = addMonths(startDate, maxUses);

  /**
   * Example: If an offer starts on May 31 and goes for 1 month, the
   * end date should be June 30, not July 1.
   */
  while (endDate.getMonth() - startDate.getMonth() > maxUses) {
    endDate = subDays(endDate, 1);
  }

  return endDate;
};
